import { render } from "./Mapa.vue?vue&type=template&id=36f639fe"
import script from "./Mapa.vue?vue&type=script&lang=js"
export * from "./Mapa.vue?vue&type=script&lang=js"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__